import React, { useEffect, useState } from 'react';
import './GoogleReviews.css';

const StarRating = ({ rating }) => {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    stars.push(
      <span key={i} style={{ color: i <= rating ? '#FFD700' : '#ccc', fontSize: '18px' }}>
        ★
      </span>
    );
  }

  return <div>{stars}</div>;
};

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = () => {
      fetch('https://getgooglereviews-xjpm53xzha-uc.a.run.app')
        .then(res => res.json())
        .then(data => setReviews(data))
        .catch(err => console.error('Error al cargar reseñas:', err));
    };

    fetchReviews();
    const interval = setInterval(fetchReviews, 1000 * 60 * 5);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="reviews-section">
      <h2>Lo que nuestros clientes dicen</h2>

      {Array.isArray(reviews) && reviews.length > 0 ? (
        <div className="reviews-list">
          {reviews
            .filter((review) => review.rating > 4)
            .slice(0, 5)
            .map((review, i) => (
              <div key={i} className="review-card">
                <img
                  src={review.profile_photo_url}
                  alt={review.author_name}
                  className="review-avatar"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/default-avatar.png';
                  }}
                />
                <div>
                  <p><strong>{review.author_name}</strong></p>
                  <StarRating rating={review.rating} />
                  <p>{review.text ? `"${review.text}"` : <em>(Sin texto)</em>}</p>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <p>No hay reseñas disponibles aún.</p>
      )}
    </div>
  );
};

export default GoogleReviews;
